<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <div v-for="record in records" :key="record.id" class="post full-width">
          <b>{{ record.date }}</b>
          &nbsp; &nbsp;
          <b>{{ record.pick }}</b>
          &nbsp; &nbsp;
          <b>{{ record.side }}</b>
          &nbsp; &nbsp;
          <b>{{ record.price }}</b>
          &nbsp; &nbsp;
          <b>{{ record.risk }}</b>
          &nbsp;
          <b>units</b>
          &nbsp; &nbsp;
          <b>{{ record.towin }}</b>
          &nbsp; &nbsp;
          <b>{{ record.result }}</b>
          &nbsp; &nbsp;
          <br />
          <router-link
            class="sml-btn blue"
            :to="{ path: '/admin/record/' + record.record_id }"
          >
            Edit
          </router-link>
          <a class="sml-btn orange" @click.prevent="remove(record)">Delete</a>
          <a class="sml-btn green" @click.prevent="update(record, 'W')">Win</a>
          <a class="sml-btn red" @click.prevent="update(record, 'L')">Loss</a>
        </div>
        <p>
          <button v-if="!hideMore" class="big-btn blue" @click.prevent="next()">
            More ->
          </button>
        </p>
      </div>
      <!-- main-colum END here -->
      <!-- sidebar START here -->
      <div id="sidebar">
        <ul>
          <!-- widget START here -->
          <li class="widget">
            <div class="title">
              <h5>Record</h5>
            </div>
            <div v-if="results" class="content">
              <p v-for="result in results" :key="result.id">
                <!--TODO: Show overall record -->
                {{ result.name }}:
                <b>{{ result.win }}-{{ result.loss }} {{ result.units }} units
                  {{ Number(result.win_percent).toFixed(2) * 100 }}%W</b>
              </p>
            </div>
          </li>
          <!-- widget END here -->
        </ul>
      </div>
      <!-- sidebar END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import RecordRepository from "../../data/record.repository.js";
import ResultRepository from "../../data/result.repository.js";
import _ from "lodash";
export default {
  data() {
    return {
      total: 0,
      current: 0,
      page: 0,
      records: [],
      results: [],
    };
  },
  computed: {
    hideMore() {
      return this.current >= this.total;
    },
  },
  created() {
    RecordRepository.get(this.page + 1).then((data) => {
      this.total = data.total;
      this.current = data.to;
      this.page = data.current_page;
      this.records = data.data;
    });
    ResultRepository.get("overall").then((data) => {
      this.results = data;
    });
  },
  methods: {
    next() {
      if (this.current >= this.total && this.page !== 0) return;
      RecordRepository.get(this.page + 1).then((data) => {
        this.total = data.total;
        this.current = data.to;
        this.page = data.current_page;
        this.records = this.records.concat(data.data);
      });
    },
    remove(record) {
      RecordRepository.remove(record)
        .then((result) => {
          _.remove(this.records, record);
          this.$root.$refs.toastr.s("Record removed");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
    update(record, result) {
      record.result = result;
      RecordRepository.save(record)
        .then((result) => {
          this.$root.$refs.toastr.s("Result saved");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ManageRecord.vue?6cb253c6